'use client';

import React from 'react';

import { type Editor } from '@tiptap/react';
import {
  Bold,
  Italic,
  List,
  ListOrdered,
  Quote,
  Strikethrough,
  Underline,
  Undo,
  Redo,
} from 'lucide-react';

type Props = {
  editor: Editor | null;
  editorType: 'comment' | 'entity';
};

const MenuBar = ({ editor }: Props) => {
  if (!editor) {
    return null;
  }
  return (
    <div
      className="flex w-full flex-wrap items-start justify-between gap-5 px-3 pt-3 pb-1"
      onClick={() => {
        editor.chain().focus();
      }}
    >
      <div className="flex w-full flex-wrap items-center justify-start gap-2 lg:w-10/12 ">
        <button
          onClick={(e) => {
            e.preventDefault();
            editor.chain().focus().undo().run();
          }}
          className={
            editor.isActive('undo') ? 'rounded-full bg-eoe-icon-hover dark:bg-eoe-gray p-1' : 'text-eoe-text-meta dark:text-eoe-dark-text-meta p-1'
          }
        >
          <Undo className="size-4" />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            editor.chain().focus().redo().run();
          }}
          className={
            editor.isActive('redo') ? 'rounded-full bg-eoe-icon-hover dark:bg-eoe-dark-icon-hover p-1' : 'text-eoe-text-meta dark:text-eoe-dark-text-meta p-1'
          }
        >
          <Redo className="size-4" />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            editor.chain().focus().toggleBold().run();
          }}
          className={
            editor.isActive('bold') ? 'rounded-full bg-eoe-icon-hover dark:bg-eoe-gray p-1' : 'text-eoe-text-meta dark:text-eoe-dark-text-meta p-1'
          }
        >
          <Bold className="size-4" />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            editor.chain().focus().toggleItalic().run();
          }}
          className={
            editor.isActive('italic') ? 'rounded-full bg-eoe-icon-hover dark:bg-eoe-gray p-1' : 'text-eoe-text-meta dark:text-eoe-dark-text-meta p-1'
          }
        >
          <Italic className="size-4" />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            editor.chain().focus().toggleUnderline().run();
          }}
          className={
            editor.isActive('underline') ? 'rounded-full bg-eoe-icon-hover dark:bg-eoe-gray p-1' : 'text-eoe-text-meta dark:text-eoe-dark-text-meta p-1'
          }
        >
          <Underline className="size-4" />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            editor.chain().focus().toggleStrike().run();
          }}
          className={
            editor.isActive('strike') ? 'rounded-full bg-eoe-icon-hover dark:bg-eoe-gray p-1' : 'text-eoe-text-meta dark:text-eoe-dark-text-meta p-1'
          }
        >
          <Strikethrough className="size-4" />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            editor.chain().focus().toggleBulletList().run();
          }}
          className={
            editor.isActive('bulletList') ? 'rounded-full bg-eoe-icon-hover dark:bg-eoe-gray p-1' : 'text-eoe-text-meta dark:text-eoe-dark-text-meta p-1'
          }
        >
          <List className="size-4" />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            editor.chain().focus().toggleOrderedList().run();
          }}
          className={
            editor.isActive('orderedList') ? 'rounded-full bg-eoe-icon-hover dark:bg-eoe-gray p-1' : 'text-eoe-text-meta dark:text-eoe-dark-text-meta p-1'
          }
        >
          <ListOrdered className="size-4" />
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            editor.chain().focus().toggleBlockquote().run();
          }}
          className={
            editor.isActive('blockquote') ? 'rounded-full bg-eoe-icon-hover dark:bg-eoe-gray p-1' : 'text-eoe-text-meta dark:text-eoe-dark-text-meta p-1'
          }
        >
          <Quote className="size-4" />
          </button>
      </div>
    </div>
  );
};

export default MenuBar;